import { Card, Flex, Loader, Text, Title } from "@mantine/core";
import EventRating from "components/Workspace/EventRating/EventRating";
import AttendeeModal from "components/Workspace/Meeting/AttendeeModal/AttendeeModal";
import Cost from "components/Workspace/Meeting/Cost/Cost";
import HasAttended from "components/Workspace/Meeting/HasAttended/HasAttended";
import StrategicGoal from "components/Workspace/Meeting/StrategicGoal/StrategicGoal";
import useEventTimeStatus from "hooks/useEventTimeStatus";
import useGoalsQuery from "hooks/useGoalsQuery";
import useMeeting from "hooks/useMeeting";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { BsPeopleFill } from "react-icons/bs";
import { MdWatchLater } from "react-icons/md";
import { checkForIncoming } from "utils/events";
const ListEvent = ({
  event,
  metaData = [],
  tags,
  user,
  refreshMetaData,
  metaDataLoading,
}) => {
  const { calendarEvent, start, end, title } = event;
  const eventTimeStatus = useEventTimeStatus(start, end);
  const canRate = eventTimeStatus.canRate;
  const [selectedTag, setSelectedTag] = useState("");
  const { data: strategicGoals } = useGoalsQuery(
    user?.subscription?.organization_id
  );
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState({
    feedbackTags: [],
    customFeedback: null,
  });
  const [hasAttended, setHasAttended] = useState(true);
  const {
    submitTag,
    submitGoal,
    submitHasAttended,
    submitRating,
    submitFeedback,
  } = useMeeting({
    selectedEventId: event?.id,
    subscribe_event: "subscribe_event",
    recurringEventId: event?.recurringEventId,
  });
  const [attendeeModalOpen, setAttendeeModalOpen] = useState(false);

  const handleHasAttended = async (value) => {
    if (hasAttended === value) return;
    await submitHasAttended(value, event?.id);
    setHasAttended(value);
  };

  useEffect(() => {
    const filtered = metaData?.find((data) => data.id === event?.id) || {};
    if (filtered) {
      setRating(filtered?.rating);
      setFeedback(filtered?.feedback);
      setSelectedTag(filtered?.tag);
      setHasAttended(filtered?.hasAttended);
    }
  }, [event, metaData, strategicGoals, user]);
  return (
    <>
      <Card
        padding="lg"
        radius="md"
        px={"xl"}
        pl={"sm"}
        sx={{
          overflow: "visible",
          transition: "all 200ms ease-in",
          cursor: "pointer",
          position: "relative",
        }}
      >
        <Flex w={"100%"} justify={"space-between"}>
          {/* left side */}
          <Flex direction={"column"} gap={".5rem"} sx={{ flex: 1 }}>
            {/* title of event */}
            <Title order={5} fw={500} fz={"1.0rem"}>
              {title}
            </Title>

            <Flex gap={"2rem"}>
              {/* time */}
              <Flex align={"center"} gap={".5rem"}>
                <MdWatchLater color="#39a8f0" size={20} />
                <Text fz={".9rem"}>
                  {moment(start).format("hh:mm A")} -{" "}
                  {moment(end).format("hh:mm A")}
                </Text>
              </Flex>

              {/* guests */}
              <Flex
                align={"center"}
                gap={".5rem"}
                onClick={() => setAttendeeModalOpen(true)}
              >
                <BsPeopleFill color="#39a8f0" size={20} />
                <Text fz={".9rem"}>
                  {calendarEvent?.attendees?.length || 0} Guests
                </Text>
              </Flex>
              <AttendeeModal
                opened={attendeeModalOpen}
                setOpened={setAttendeeModalOpen}
                organizer={calendarEvent?.organizer}
                attendees={calendarEvent?.attendees || []}
              />

              <Cost
                calendarEvent={{ ...calendarEvent, eventId: event?.id }}
                start={start}
                end={end}
              />
            </Flex>

            {/* id */}
            {/* <Text fz={".9rem"}>{event?.id}</Text> */}
          </Flex>

          {/* righ side */}
          {metaDataLoading ? (
            <Flex align={"center"} justify={"center"} sx={{ flex: 1 }}>
              <Loader variant="dots" sx={{ marginLeft: "6rem" }} />
            </Flex>
          ) : (
            <Flex gap={"4rem"} align={"center"}>
              {/* has Attended */}
              <HasAttended
                hasAttended={hasAttended}
                onUpdateHasAttended={handleHasAttended}
              />

              {user?.subscription?.plan === "ENTERPRISE" && (
                <StrategicGoal
                  goals={strategicGoals}
                  selectedEvent={{
                    ...event?.calendarEvent,
                    eventId: event?.id,
                  }}
                  submitGoal={submitGoal}
                  refreshMetaData={refreshMetaData}
                  source={"events"}
                />
              )}

              {/* tag */}
              {/* <MeetingTagsDropdownNew
                key={event?.id}
                tagOptions={tags}
                currentTag={selectedTag}
                handleOnClick={(tagOption) => {
                  setSelectedTag(tagOption);
                  submitTag(tagOption, event?.id);
                }}
              /> */}

              {/* event rating */}
              <div
                align={"center"}
                gap="md"
                onClick={(e) => {
                  e.stopPropagation();
                  checkForIncoming(
                    {
                      ...event,
                      hasEventEnded: eventTimeStatus.hasEventEnded,
                      isOngoing: eventTimeStatus.isOngoing,
                    },
                    hasAttended
                  );
                }}
              >
                <EventRating
                  rating={rating}
                  setRating={setRating}
                  eventId={event?.id}
                  feedback={feedback}
                  readOnly={!canRate}
                  currentTag={selectedTag}
                  tagOptions={tags}
                  handleOnTagClick={(tagOption) => {
                    setSelectedTag(tagOption);
                    submitTag(tagOption, event?.id);
                  }}
                  meetingTitle={title}
                  hasAttended={hasAttended}
                  onUpdateRating={submitRating}
                  onFeedBackUpdate={submitFeedback}
                />
              </div>
            </Flex>
          )}
        </Flex>
      </Card>
    </>
  );
};

export default ListEvent;
